<template>
    <div id="user_logs">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <Filters></Filters>

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="user_log in user_logs"
                    :key="user_log.identity"
                    :object="user_log"
                    :title="user_log.loggable_type"
                    :title_link="{name: 'user_log', params: {identity: user_log.identity}}"
                    :date="human_datetime(user_log.created_at)"
                    :sub_title="user_log.code"
                    :is_show_column="true"
                    :keys="['title','action_type','operator']"
                    :i_18n_key="'user_logs'"
                >
                </DataCard>

                <div v-if="!is_loading && user_logs.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui celled table">
                <thead class="center aligned">
                    <tr>
                        <th>{{ $t('ui.pages.user_logs.record_object') }}</th>
                        <th>{{ $t('models.attributes.user_logs.title') }}</th>
                        <th>{{ $t('models.attributes.user_logs.action_type') }}</th>
                        <th>{{ $t('ui.pages.user_logs.operator') }}</th>
                        <th>{{ $t('models.attributes.user_logs.created_at') }}</th>
                        <th>{{ $t('ui.general.operate') }}</th>
                    </tr>
                </thead>
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="6">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else class="center aligned">
                    <UserLog v-for="user_log in user_logs" :key="user_log.identity" :user_log="user_log">
                    </UserLog>
                    <tr v-if="user_logs.length <= 0" class="center aligned">
                        <td colspan="6" >
                            <h5>{{ $t('ui.general.no_data') }}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>

            <Paginator
                :total_pages="total_pages"
                :current_page="current_page"
                :disabled="is_loading"
                >
            </Paginator>
        </div>
    </div>
</template>

<script>
import UserLog from "../.components/index/user_log.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
import DataCard from '@toolbox/data_card/main.vue'
import Filters from "./filter/main.vue"

export default {
    name: "UserLogsIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.user_logs_module
        },
        user_logs() {
            return this.current_store.user_logs
        },
        pagination() {
            return this.current_store.pagination
        },
        current_page() {
            return this.current_store.pagination.current_page
        },
        total_pages() {
            return this.current_store.pagination.total_pages
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
        this.init()
        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
        this.pagination.current_page = 1
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
    },
    methods: {
        async init(is_first = true) {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_loading = true
                    resolve()
                })
                await this.$store.dispatch('provider/user_logs_module/handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch('provider/user_logs_module/handle_quick_filter_key')
                }
                await this.$store.dispatch('provider/user_logs_module/fetch_user_logs')
                await new Promise(resolve => {
                    this.$noty.information(
                        this.$t("ui.page_titles.user_logs") + ' ' +
                        this.$t('ui.general.initialize_complete')
                    , 300)

                    resolve()
                })
            } catch (e) {
                console.log(e)
                this.$noty.error("非預期的錯誤: " + e)
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.user_logs'),
                        reason: e
                    })
                )
            } finally {
                this.is_initialized = true
                this.is_loading = false
            }
        },
        user_logs_filter() {
            console.log('user_logs_filter')
            try {
                this.$router.push({
                    name: this.$router.name,
                    query: this.$store.getters['provider/user_logs_module/filter_to_query'],
                })
            } catch (e) {
                console.log(e)
            }
        },
    },
    components: {
        UserLog,
        Paginator,
        ErrorMessages,
        DataCard,
        Filters
    }
}
</script>
<style scoped>
#user_logs {
    /*overflow-x: auto;*/
}
</style>
